<template>
	<div v-if="content.levels_messages" id="app" :class="zoomClass">
		<Menu />
		<Main3D />
		<transition name="page-animation">
			<Experience v-if="isEntityGood" id="experience" />
		</transition>
		<div class="logo-container">
			<img src="./assets/gta-logo-white.svg" class="logo" />
		</div>
		<audio ref="audioSource" autoplay loop>
			<source src="../public/assets/sound/sound.mp3" type="audio/mp3" />
		</audio>
		<div class="animation-plus"></div>
		<div class="animation-minus"></div>
	</div>
</template>
<style lang="scss">
	audio {
		display: none;
	}
	body {
		width: 100vw;
		height: 100vh;
		overflow: hidden;
		margin: 0;
		background-color: lightGrey;
		#app {
			width: 100vw;
			height: 100vh;
			overflow: hidden;
			position: relative;

			.logo-container {
				z-index: 20;
				position: absolute;
				top: 2rem;
				left: 4rem;
				height: 3.4rem;
				img.logo {
					height: 100%;
				}
			}
			#experience {
				z-index: 10;
				position: absolute;
				top: 0;
				left: 0;
			}

			.animation-plus,
			.animation-minus {
				position: absolute;
				background-color: var(--black-2);
				width: 150%;
				height: 100%;
				top: 0;
				opacity: 1;
			}

			.animation-plus {
				left: -150%;
				will-change: left;
				transition: left 1.2s ease;
				// transition: left 2s cubic-bezier(0.21, 1.05, 0.82, 0.2);
			}
			.animation-minus {
				right: -150%;
				will-change: right;
				transition: right 1.2s ease;
				// transition: right 2s cubic-bezier(0.21, 1.05, 0.82, 0.2);
			}

			&.zoom-plus {
				.animation-plus {
					z-index: 100;
					left: 150%;
				}
			}
			&.zoom-minus {
				.animation-minus {
					z-index: 100;
					right: 150%;
				}
			}
		}
		.page {
			width: 100vw;
			height: 100vh;
		}

		button {
			background: transparent;
			box-shadow: 0px 0px 0px transparent;
			border: 0px solid transparent;
			text-shadow: 0px 0px 0px transparent;

			&:hover {
				background: transparent;
				box-shadow: 0px 0px 0px transparent;
				border: 0px solid transparent;
				text-shadow: 0px 0px 0px transparent;
			}

			&:active {
				outline: none;
				border: none;
			}

			&:focus {
				outline: 0;
			}
		}
		i.icon {
			height: 100%;
			img {
				height: 100%;
			}
		}
	}
	canvas,
	canvas.three {
		width: 100%;
		height: 100%;
	}

	//page animation
	.page-animation-enter-active {
		opacity: 1;
		transition: opacity 2s;
	}

	.page-animation-enter {
		opacity: 0;
	}
</style>
<script>
	import Menu from "./components/Menu.vue";
	import { mapActions, mapState } from "vuex";
	import Experience from "./views/Experience.vue";
	import Main3D from "./views/Main3D.vue";
	export default {
		components: {
			Menu,
			Main3D,
			Experience,
		},
		data() {
			return {
				zoomzoom: false,
				zoomClass: "",
				zoomTimeOut: undefined,
			};
		},
		computed: {
			...mapState(["soundStatus", "content", "isEntityGood", "currentZoom"]),
		},
		watch: {
			soundStatus() {
				if (this.soundStatus) {
					this.$refs.audioSource.play();
				} else {
					this.$refs.audioSource.pause();
				}
			},
			currentZoom(newValue, oldValue) {
				if (typeof this.zoomTimeOut !== "undefined") clearTimeout(this.zoomTimeOut);

				if (newValue > oldValue) {
					this.zoomClass = "zoom-plus";
				} else if (newValue < oldValue) {
					this.zoomClass = "zoom-minus";
				}

				// reset zoomClass
				this.zoomTimeOut = setTimeout(() => {
					this.zoomClass = "";
				}, 2000);
			},
		},
		async mounted() {
			await this.fetchContent();
			this.onMountSoundHandler();
			document.title = this.content.page_title;
		},
		methods: {
			...mapActions(["fetchContent", "toggleSound"]),
			onMountSoundHandler() {
				this.$refs.audioSource.play();
				// check if audio is correctly working
				if (!this.$refs.audioSource.pause) {
					this.toggleSound({ status: true });
				}
			},
		},
	};
</script>
